import { render, staticRenderFns } from "./separate.vue?vue&type=template&id=35049e60&scoped=true&"
import script from "./separate.vue?vue&type=script&lang=js&"
export * from "./separate.vue?vue&type=script&lang=js&"
import style0 from "./separate.vue?vue&type=style&index=0&id=35049e60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35049e60",
  null
  
)

export default component.exports